import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { rem } from 'design-system';
import Text from 'design-system/Text';
import ItemBadgeWrapper from './ItemBadgeWrapper';
import BadgeLogo from './BadgeLogo';
import IconCover from './icons/IconCover';
const MerchantItemBadge = ({ filter, onPress, scrollY, handleClose, scrollToItem, isActiveKeyboard, }) => {
    const Icons = useMemo(() => {
        const filtersLen = filter.length;
        const slicedFilters = filter.slice(0, 5);
        const selectedFiltersLen = slicedFilters.length;
        if (filtersLen < 4) {
            return (<View style={styles.container}>
          {slicedFilters.map((eachFilter) => (<View key={eachFilter.id} style={styles.categoryIcon}>
              <BadgeLogo iconUrl={eachFilter.iconUrl} name={eachFilter.displayName}/>
            </View>))}
        </View>);
        }
        return (<View style={[styles.absContainer, { width: selectedFiltersLen === 4 ? rem(56) : rem(68) }]}>
        {slicedFilters.map((eachFilter, index) => (<View key={eachFilter.id} style={[[styles.absCategoryIcon, { left: index * rem(12), zIndex: -index }]]}>
            <BadgeLogo iconUrl={eachFilter.iconUrl} name={eachFilter.displayName}/>
          </View>))}
        {filtersLen > 5 && (<View style={styles.gradientContainer}>
            <IconCover scrollY={scrollY}/>
          </View>)}
      </View>);
    }, [filter, scrollY]);
    const Content = useMemo(() => {
        const filterLength = filter.length;
        return <Text Text-14>{filterLength === 1 ? filter[0].badgeText : `${filterLength} merchants`}</Text>;
    }, [filter]);
    return (<ItemBadgeWrapper scrollY={scrollY} handlePress={onPress} onCancel={handleClose} scrollToItem={scrollToItem} isActiveKeyboard={isActiveKeyboard}>
      <View style={styles.container}>
        {Icons}
        {Content}
      </View>
    </ItemBadgeWrapper>);
};
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    absContainer: {
        height: rem(16),
        flexDirection: 'row',
    },
    categoryIcon: {
        marginRight: rem(4),
    },
    absCategoryIcon: {
        top: 0,
        bottom: 0,
        position: 'absolute',
    },
    gradientContainer: {
        top: 0,
        bottom: 0,
        right: rem(4),
        width: rem(24),
        position: 'absolute',
    },
});
export default MerchantItemBadge;
